<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <div>
          This page hasn't been written yet.
          Do you want to add to the story?
      </div>
      <v-spacer></v-spacer>
    </v-row>

    <v-row>
      <v-spacer></v-spacer>
      <v-btn class="success" :loading="loading" @click="checkoutPage" >Add to the Story</v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="mt-3">
      <v-spacer></v-spacer>
      <a @click="$router.go(-1)">Go back to the last page.</a>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <span class="red--text">{{errtext}}</span>
      <v-spacer></v-spacer>
    </v-row>

  </v-container>
</template>

<script>
import config from '../config.js'
// import utils from '../utils.js'

export default {
  name: 'AskToLoginView',
  props: {
    userPassword: {
      type: String,
      default: null
    }
  },
  data: () => ({
    storyPasswords: null, // this.$props.userPassword,
    loading: false,
    errtext: null

  }),
  mounted () {
    this.storyPasswords = this.$props.userPassword
  },
  methods: {
    checkoutPage: function () {
      this.loading = true
      this.errtext = null
      const dynFunction = config.getFunctions().httpsCallable('dynFunction')

      // Validate the story password
      // Get the page lock
      // Save evereything
      dynFunction({
        call: 'checkoutPage',
        storyPasswords: this.storyPasswords,
        storyID: this.$route.params.storyID,
        pageID: this.$route.params.pageID
      }).then((rc) => {
        // Check if we got the lock
        var status = rc.data.status
        if (status === 'WRONGPASS') {
          this.errtext = 'Oops. Your story password was incorrect.'
        } else if (status === 'NOLOCK') {
          this.errtext = 'Oops. Someone else is already writing this page.'
        } else if (status === 'LOCKED') {
          var lockID = rc.data.lockID

          // Store the password and lockID
          // utils.addStoryPassword(this.$cookies, this.storyPasswords)

          this.$cookies.set('lockID', lockID, '2h')

          // Tell ReadStory.vue to set the status to LOCKED_CANEDIT
          this.$emit('setLockedCanEdit')
          this.loading = false
        }
      }).catch((err) => {
        console.error('Error checkoutPage: ' + err)
        this.errtext = err
        this.loading = false
      })
    }
  }
}
</script>
